import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const WishlistProduct = () => {
    return (
        <div className="wishlist-product-wrapper">
            <div className="list-product blue-product position-relative xmt-6">
                <div className="price-box position-absolute">
                    <span className="price persian-number">۲،۷۶۰،۰۰۰ ت</span>
                </div>
                <div className="content-cart d-flex align-items-center">
                    <div className="img-product">
                        <img src="./assets/sample-image/1420-w320h320.png" alt="img"/>
                    </div>
                    <div className="info-product">
                        <div className="title-product">
                            <h2 className="big-title persian-number d-none d-lg-block">گوشی شیائومی می نوت 9 پرو دوسیم
                                کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ
                                رم</h2>
                            <h3 className="small-title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                        </div>
                        <div className="color-product d-flex align-items-center">
                            <span className="color black">
                            </span>
                            <span className="text-color">مشکی</span>
                        </div>

                        <div className="text-info-product-responsive">
                            <div className="text-product-information xmb-2">
                                <IconName name="verified_user" className="icon"/>
                                <span className="text">گارانتی ۱۸ ماهه‌ی سایمان</span>
                            </div>
                            <div className="text-product-information xmb-2">
                                <IconName name="add_business" className="icon"/>
                                <span className="text">کامپیوتر زرد </span>
                            </div>
                            <div className="text-product-information xmb-2">
                                <IconName name="date" className="icon"/>
                                <span className="text">ارسال کالا از ۱ روز کاری آینده</span>
                            </div>
                        </div>


                        <div className="add-remove-buttons d-flex align-items-center xmt-6">
                            <div className="add-button xml-2">
                                <IconName name="add_shopping_cart" className="icon"/>
                                <span className="text">افزودن به سبد خرید</span>
                            </div>
                            <div className="remove-button">
                                <IconName name="delete" className="icon"/>
                                <span className="text">حذف محصول</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="list-product out-of-stock position-relative xmt-6">
                <div className="price-box position-absolute">
                    <span className="price persian-number">ناموجود</span>
                </div>
                <div className="content-cart d-flex align-items-center">
                    <div className="img-product">
                        <img src="./assets/sample-image/Mi-Band-5-removebg-preview.png" alt="img"/>
                    </div>
                    <div className="info-product">
                        <div className="title-product">
                            <h2 className="big-title persian-number d-none d-lg-block">شیائومی می بند 5 نسخه گلوبال</h2>
                            <h3 className="small-title">Xiaomi Mi Band 5 Global Version XMSH10HM</h3>
                        </div>
                        <div className="color-product d-flex align-items-center">
                            <span className="color black">
                            </span>
                            <span className="text-color">مشکی</span>
                        </div>

                        <div className="text-info-product-responsive">
                            <div className="text-product-information xmb-2">
                                <IconName name="verified_user" className="icon"/>
                                <span className="text">گارانتی ۱۸ ماهه‌ی سایمان</span>
                            </div>
                            <div className="text-product-information xmb-2">
                                <IconName name="add_business" className="icon"/>
                                <span className="text">کامپیوتر زرد </span>
                            </div>
                            <div className="text-product-information xmb-2">
                                <IconName name="date" className="icon"/>
                                <span className="text">ارسال کالا از ۱ روز کاری آینده</span>
                            </div>
                        </div>


                        <div className="add-remove-buttons d-flex align-items-center xmt-6">
                            <div className="remove-button">
                                <IconName name="delete" className="icon"/>
                                <span className="text">حذف محصول</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WishlistProduct;
